import { Content } from "./styles";

const Component = ({ children }) => {
  return <Content>{children}</Content>;
};

export default Component;
